<template>
  <div>
    <vue-tabs class="row" direction="vertical" @tab-change="tabChange">
      <v-tab title="General Log">
        <div v-if="generalLog">
          <el-table :data="generalLog.parts">
            <el-table-column label="Time" prop="time" width="250"></el-table-column>
            <el-table-column label="Type" width="100">
              <template slot-scope="scope">
                <span class="label " :class="'label-'+scope.row.type.toLowerCase()">{{ scope.row.type }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Message" prop="message"></el-table-column>
          </el-table>
        </div>
      </v-tab>
      <v-tab title="WebGrab++.log.txt">
        <div class="form-group">
          <select class="form-control" v-model="webgrabThread">
            <option v-for="thread in threads" :value="thread">Thread {{ thread }}</option>
          </select>
        </div>
        <log-loader :process_id="process_id" :server_id="server_id" :type="2" :thread="webgrabThread"/>
      </v-tab>
      <v-tab title="WGLicense.log.txt">
        <div class="form-group">
          <select class="form-control" v-model="licenseThread">
            <option v-for="thread in threads" :value="thread">Thread {{ thread }}</option>
          </select>
        </div>
        <log-loader :process_id="process_id" :server_id="server_id" :type="3" :thread="licenseThread"/>
      </v-tab>
    </vue-tabs>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import LogLoader from "./LogTabs/LogLoader";

export default {
  components: {LogLoader},
  props: ['process_id', 'server_id', 'threads'],
  mounted () {
    // this.$refs.webgrabLog.addEventListener('scroll', this.webgrabLogScrollHandler)
  },
  beforeDestroy () {

  },
  // watch: {
  //   webgrabLog: function (data) {
  //     if (data) {
  //       this.$nextTick(function () {
  //         this.$refs.webgrabLog.addEventListener('scroll', this.webgrabLogScrollHandler);
  //         this.webgrabLogScrollHandler({target: this.$refs.webgrabLog})
  //       })
  //     }
  //   }
  // },
  computed: {
    ...mapGetters(['logbookGetList']),
    generalLog: function () {
      return this.logbookGetList.find(log => {
        return log.process_id === this.process_id &&
          log.server_id === this.server_id &&
          log.type === 1
      });
    },
  },
  data: function () {
    return {
      webgrabThread: 1,
      licenseThread: 1
    };
  },
  methods: {
    ...mapActions(['logbookGetPage']),
    tabChange: async function (index) {
      // if (index === 1 && this.webgrabLog && !this.webgrabInit) {
      //   await this.logbookGetPage({id: this.webgrabLog.id, page: this.webgrabNextPage});
      //   this.webgrabNextPage++;
      //   this.$refs.webgrabLog.addEventListener('scroll', this.webgrabLogScrollHandler);
      // }
      //
      // if (index === 2 && this.licenseLog && !this.licenseInit) {
      //   await this.logbookGetPage({id: this.licenseLog.id, page: this.licenseNextPage});
      //   this.licenseNextPage++;
      //   this.$refs.licenseLog.addEventListener('scroll', this.licenseLogScrollHandler);
      // }
    },

  }
}
</script>
<style>
.log-content {
  text-align: left;
  max-height: 70vh;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logbook/LogTabs.vue